import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// The self-hosted Inter (variable weight). Vite bundles its woff2 files under
// `/assets`, so the static server's `font-src 'self'` holds (no font CDN).
import "@fontsource-variable/inter";
// The three design-system sheets, in this order: `tokens.css` declares the
// palette, the light aliases and the scales, `themes.css` remaps the aliases
// per theme, and `base.css` applies them to the document.
import "./shared/design-system/tokens.css";
import "./shared/design-system/themes.css";
import "./shared/design-system/base.css";
import { AppProviders } from "./app/providers";
import { AppRouter } from "./app/router";

// The application entry point. It owns the mount, the five providers of design
// section 4 and, inside them, the sixth: the router.
const mountPoint = document.getElementById("root");

if (mountPoint === null) {
  throw new Error("index.html must declare the #root mount point");
}

createRoot(mountPoint).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
